import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';

@Component({
  selector: 'app-working',
  templateUrl: './working.component.html',
  styleUrls: ['./working.component.css']
})
export class WorkingComponent implements OnInit {

  constructor() { 
  }
change(){
document.getElementById("body1").style.backgroundColor ="white";
}
  today = new Date(); // aktuelles Datum und aktuelle Zeit
  

public y = this.today.getFullYear();
public mo = this.today.getMonth();
// public count = this.today.getDay();
public h = this.today.getHours();
public m = this.today.getMinutes();
public s = this.today.getSeconds();
public count1 = 1;
public day = "Montag";
ab;
ac;
ad;
ae;
af;
ag;
startdownload(){    
  
  
   const heute = new Date(); // aktuelles Datum und aktuelle Zeit
   var ha = heute.getMonth();     // liefert 0 - 11
   var h1 = heute.getFullYear();  // YYYY (startet nicht bei 0)
   var h2 = heute.getDate();      // liefert 1 - 31
   var h3 = heute.getDay();       // Tag der Woche (startet am Sonntag mit 0)
   var h4 = heute.getHours();     // liefert 0 - 23
   var h5 = heute.getMinutes();   // liefert 0 - 59
  //  document.getElementById("ja").innerHTML = ""+heute;
  ha = ha +1;
  var datum = h2 + ":" + ha + ":" + h1;
  this.download( "Stunden.txt", "Datum: "+ datum + "\r\n" + "Beginn der Arbeit um: " + this.ab + "\r\n" + "Ende der Arbeit um: " + this.ac + "\r\n" + "Beginn der Pause um: " + this.ad + "\r\n" + "Ender der Pause um: " + this.ae + "\r\n" + "Informationen: " + this.af + "\r\n" + "Mitarbeiter: " + this.ag);
}
  // public date1 = this.count + ":" + this.mo +  ":" + this.y ;
  public date = this.mo + "";
  public monat;
  startTime(){
    this.whichMonth();
    this.whichYear();
    const heute = new Date(); // aktuelles Datum und aktuelle Zeit
    var ha = heute.getMonth();     // liefert 0 - 11
    var h1 = heute.getFullYear();  // YYYY (startet nicht bei 0)
    var h2 = heute.getDate();      // liefert 1 - 31
    var h3 = heute.getDay();       // Tag der Woche (startet am Sonntag mit 0)
    var h4 = heute.getHours();     // liefert 0 - 23
    var h5 = heute.getMinutes();   // liefert 0 - 59
    document.getElementById('i6').innerHTML = "" + h2;
  }
  whichYear(){
    const heute = new Date(); // aktuelles Datum und aktuelle Zeit
    var ha = heute.getMonth();     // liefert 0 - 11
    var h1 = heute.getFullYear();  // YYYY (startet nicht bei 0)
    var count = heute.getDate();      // liefert 1 - 31
    var h3 = heute.getDay();       // Tag der Woche (startet am Sonntag mit 0)
    var h4 = heute.getHours();     // liefert 0 - 23
    var h5 = heute.getMinutes();   // liefert 0 - 59
    document.getElementById("i7").innerHTML = h1 + "";
  }
  whichMonth(){
    const heute = new Date(); // aktuelles Datum und aktuelle Zeit
    var ha = heute.getMonth();     // liefert 0 - 11
    var h1 = heute.getFullYear();  // YYYY (startet nicht bei 0)
    var h2 = heute.getDate();      // liefert 1 - 31
    var h3 = heute.getDay();       // Tag der Woche (startet am Sonntag mit 0)
    var h4 = heute.getHours();     // liefert 0 - 23
    var h5 = heute.getMinutes();   // liefert 0 - 59
    if(ha == 0){
      this.monat = "Januar";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else if(ha == 1){
      this.monat = "Februar";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else if(ha == 2){
      this.monat = "März";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else if(ha == 3){
      this.monat = "April";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else if(ha == 4){
      this.monat = "Mai";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else if(ha == 5){
      this.monat = "Juni";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else if(ha == 6){
      this.monat = "july";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else if(ha == 7){
      this.monat = "August";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else if(ha == 8){
      this.monat = "September";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else if(ha == 9){
      this.monat = "Oktober";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else if(ha == 10){
      this.monat = "November";
      document.getElementById("i8").innerHTML = this.monat;
    }
    else{
      this.monat = "Dezember";
      document.getElementById("i8").innerHTML = this.monat;

    }
  }
  pluseins(){
  
    this.count = this.count +1;
    if(32 <=  this.count){
    }else{
    document.getElementById('i6').innerHTML = "" + this.count;
    console.log('+1');
  }
  }
  heute = new Date(); // aktuelles Datum und aktuelle Zeit
    public count = this.heute.getDate();      // liefert 1 - 31
    
  minuseins(){
    
    this.count =  this.count -1;
    if( this.count <= 0){
    }else{
      document.getElementById('i6').innerHTML = "" +  this.count;
      console.log('-1');
    }
  }
  pluseintag(){
    console.log('+1Tag')
    this.day = this.day = "Dienstag";
    this.count1 = this.count1 + 1;
    if (this.count1 == 3) {
      this.day = this.day = "Mittwoch";
    }
    else if (this.count1 == 4) {
      this.day = this.day = "Donnerstag";
    }
    else if (this.count1 == 5) {
      this.day = this.day = "Freitag";
    }
    else if (this.count1 == 6) {
      this.day = this.day = "Samstag";
    }
    else if (this.count1 == 7) {
      this.day = this.day = "Sonntag";
    }
    else if (this.count1 == 8) {
      this.day = this.day = "Montag";
      this.count1 = this.count1 = 1;
    }
  }
  ngOnInit() {
  this.change();
  }
  download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    element.click();
  
    document.body.removeChild(element);
  }

}
